import React from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";

/**
 * AssoCannotBuyNotice — message affiché quand une ASSOCIATION connectée tente
 * une action réservée aux comptes personnels (acheter, mettre en favoris,
 * suivre une association). Les comptes association servent à gérer les dons
 * et les annonces ; l'achat/favoris arrivera plus tard pour elles.
 *
 * - Composant (bandeau) : à rendre à la place du bloc d'achat sur la fiche.
 * - notifyAssoCannot(action) : toast pour les actions ponctuelles (clic cœur,
 *   bouton suivre) où il n'y a pas de zone de rendu dédiée.
 */
const VERB = {
  buy: "acheter",
  favorite: "ajouter une annonce à vos favoris",
  follow: "suivre une association",
  contact: "contacter un vendeur",
};

export function notifyAssoCannot(action = "buy") {
  toast.info(
    `Un compte association ne peut pas ${VERB[action] || "réaliser cette action"}. ` +
      "Nous vous invitons à vous connecter avec un compte utilisateur."
  );
}

export default function AssoCannotBuyNotice({ action = "buy", className = "" }) {
  const navigate = useNavigate();
  return (
    <div className={`bg-amber-50 border border-amber-200 rounded-xl p-4 ${className}`} data-testid="asso-cannot-buy-notice">
      <p className="text-sm font-semibold text-amber-900 mb-1">💜 Compte association</p>
      <p className="text-xs text-amber-800 leading-relaxed mb-3">
        Un compte association ne {action === "follow" ? "suit pas d'autres associations" : "peut pas acheter ni ajouter aux favoris"}.
        Nous vous invitons à vous connecter avec un compte utilisateur.
      </p>
      <button
        type="button"
        onClick={() => navigate("/register")}
        className="w-full py-2.5 bg-[#1DA1F2] text-white text-sm font-semibold rounded-xl hover:bg-[#0d8ecf] transition-colors"
      >
        Créer un compte personnel
      </button>
    </div>
  );
}
